module.exports = __webpack_public_path__ + "img/tradein.98277d9e.svg";